var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2978 2.13398C12.6053 1.62533 14 2.62804 14 4.07667V15.1322V19.9242C14 21.274 12.7772 22.2644 11.5149 21.937L5.51493 20.3809C4.6246 20.15 4 19.3201 4 18.3681V6.41082C4 5.54595 4.51714 4.7718 5.29775 4.46812L11.2978 2.13398ZM12 4.07667L6 6.41082V18.3681L12 19.9242V15.1322V4.07667ZM8.99999 11.9163C8.99999 11.3433 9.44771 10.8789 9.99999 10.8789C10.5523 10.8789 11 11.3433 11 11.9163C11 12.4892 10.5523 12.9537 9.99999 12.9537C9.44771 12.9537 8.99999 12.4892 8.99999 11.9163ZM16 3.6171C15.4477 3.6171 15 4.08156 15 4.6545C15 5.22744 15.4477 5.6919 16 5.6919H18V14.4176V18.1407H16C15.4477 18.1407 15 18.6051 15 19.1781C15 19.751 15.4477 20.2155 16 20.2155H18C19.1046 20.2155 20 19.2865 20 18.1407V14.4176V5.6919C20 4.54602 19.1046 3.6171 18 3.6171H16Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorIn);
export default __webpack_public_path__ + "static/media/door_in.846a173ed1b9f7a72e7e58383c3f329e.svg";
export { ForwardRef as ReactComponent };